import React from 'react';
import { Link } from 'react-router-dom';

const sb = { borderLeft:'3px solid var(--gold)', padding:'.75rem 1.5rem', background:'rgba(197,165,90,0.04)' };
const sbText = { fontFamily:"'Playfair Display',serif", fontStyle:'italic', fontSize:'1.05rem', lineHeight:1.8, color:'rgba(245,240,232,0.92)', marginBottom:'.25rem' };
const sbRef = { fontFamily:"'Oswald',sans-serif", fontSize:'.8rem', letterSpacing:2, color:'var(--gold)' };

const NATIONS = [
  { flag:'🇺🇸', name:'American', note:'The most prosperous nation in history.' },
  { flag:'🇬🇧', name:'British', note:'Once ruled a quarter of the earth.' },
  { flag:'🇩🇪', name:'German', note:'Home of the Reformation.' },
  { flag:'🇮🇹', name:'Italian', note:'Seat of the Roman Empire.' },
  { flag:'🇫🇷', name:'French', note:'Shaped Western civilization.' },
  { flag:'🇨🇦', name:'Canadian', note:'Known for decency and peace.' },
  { flag:'🇧🇷', name:'Brazilian', note:'Largest Christian population in South America.' },
  { flag:'🇰🇷', name:'Korean', note:'Sent more missionaries than nearly any nation.' },,
  { flag:'🇦🇺', name:'Australian', note:'Founded by people seeking a new beginning.' },
];

const EMPIRES = [
  { name:'Egypt', years:'~3100 BC - 30 BC', note:'Enslaved God\'s people. Judged by ten plagues. Collapsed.' },
  { name:'Assyria', years:'~2500 BC - 609 BC', note:'Conquered Israel. God destroyed Nineveh as prophesied.' },
  { name:'Babylon', years:'~1895 BC - 539 BC', note:'Took Judah captive. Fell in a single night (Daniel 5).' },
  { name:'Persia', years:'~550 BC - 330 BC', note:'Allowed Israel to return. Rose and fell by God\'s hand.' },
  { name:'Greece', years:'~800 BC - 146 BC', note:'Alexander conquered the known world. Dead at 32.' },
  { name:'Rome', years:'~753 BC - 476 AD', note:'Crucified Christ. Persecuted Christians. Crumbled from within.' },
  { name:'British Empire', years:'~1583 - 1997', note:'Ruled a quarter of the earth. Now a fraction of its former self.' },
];

export default function American() {
  return (
    <>
      {/* HERO */}
      <section className="hero" style={{ background:'linear-gradient(165deg,var(--navy) 0%,var(--deep-blue) 40%,var(--royal) 100%)', minHeight:'auto', padding:'5rem 2rem 4rem', position:'relative', overflow:'hidden' }}>
        <div style={{ position:'absolute', top:0, left:0, right:0, bottom:0, opacity:.03, pointerEvents:'none' }}>
          {Array.from({length:13},(_,i) => (
            <div key={i} style={{ height:'7.69%', background: i%2===0 ? '#B22234' : '#fff' }} />
          ))}
        </div>
        <div className="inner" style={{ textAlign:'center', position:'relative', zIndex:1 }}>
          <div className="section-label center">A Truth Every Nation Needs to Hear</div>
          <h1 className="section-title" style={{ fontSize:'clamp(1.8rem,5vw,3.2rem)', marginBottom:'1.25rem', lineHeight:1.15 }}>
            Why Being American<br />Doesn't Make You<br />Right with God
          </h1>
          <p style={{ fontSize:'1.1rem', fontFamily:"'Playfair Display',serif", fontStyle:'italic', color:'rgba(245,240,232,0.8)', maxWidth:600, margin:'0 auto 2rem' }}>
            Your passport does not permit you into heaven.
          </p>
          <div style={{ ...sb, maxWidth:600, margin:'0 auto', textAlign:'left' }}>
            <p style={sbText}>"For there is no difference between the Jew and the Greek: for the same Lord over all is rich unto all that call upon him."</p>
            <p style={sbRef}>Romans 10:12</p>
          </div>
        </div>
      </section>

      <div className="divider" />

      {/* NATIONALITY GRID */}
      <section style={{ background:'linear-gradient(180deg,var(--navy),var(--deep-blue))' }}>
        <div className="inner">
          <h2 className="section-title" style={{ fontSize:'clamp(1.4rem,3vw,2rem)' }}>No Nationality Has Ever<br />Saved a Single Soul</h2>
          <p style={{ textAlign:'center', color:'rgba(245,240,232,0.6)', marginBottom:'2.5rem', maxWidth:600, margin:'0 auto 2.5rem' }}>
            The flag you were born under does not determine where you spend eternity.
          </p>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(180px,1fr))', gap:'1rem' }}>
            {NATIONS.map((n,i) => (
              <div key={i} style={{ textAlign:'center', padding:'1.5rem 1rem', background:'rgba(255,255,255,0.03)', border:'1px solid rgba(197,165,90,0.08)', transition:'.3s' }}>
                <div style={{ fontSize:'2.5rem', marginBottom:'.5rem' }}>{n.flag}</div>
                <p style={{ fontFamily:"'Oswald',sans-serif", fontSize:'.85rem', letterSpacing:2, color:'var(--white)', textTransform:'uppercase', marginBottom:'.25rem' }}>{n.name}</p>
                <p style={{ fontSize:'.75rem', color:'rgba(245,240,232,0.45)', lineHeight:1.5 }}>{n.note}</p>
              </div>
            ))}
          </div>
          <p style={{ textAlign:'center', fontFamily:"'Playfair Display',serif", fontStyle:'italic', fontSize:'1.1rem', color:'rgba(245,240,232,0.7)', marginTop:'2rem', maxWidth:550, margin:'2rem auto 0' }}>
            Only one question matters: do you trust in Jesus Christ?
          </p>
        </div>
      </section>

      <div className="divider divider-gold" />

      {/* EMPIRES */}
      <section style={{ background:'var(--deep-blue)' }}>
        <div className="inner">
          <h2 className="section-title" style={{ fontSize:'clamp(1.4rem,3vw,2rem)' }}>Every Empire Falls.<br />Every Soul Lives Forever.</h2>
          <p style={{ textAlign:'center', color:'rgba(245,240,232,0.6)', marginBottom:'2rem', maxWidth:600, margin:'0 auto 2rem' }}>
            The mightiest civilizations in human history are now dust. The souls that lived in them are still alive, somewhere, right now.
          </p>
          <div style={{ maxWidth:650, margin:'0 auto' }}>
            {EMPIRES.map((e,i) => (
              <div key={i} style={{ display:'flex', alignItems:'flex-start', gap:'1.25rem', padding:'1.25rem 0', borderBottom:'1px solid rgba(197,165,90,0.08)' }}>
                <div style={{ fontFamily:"'Playfair Display',serif", fontSize:'1.8rem', fontWeight:700, color:'var(--crimson)', opacity:.4, minWidth:40, textAlign:'center', lineHeight:1 }}>{i+1}</div>
                <div>
                  <p style={{ fontFamily:"'Oswald',sans-serif", fontSize:'.85rem', letterSpacing:2, color:'var(--gold)', textTransform:'uppercase' }}>{e.name} <span style={{ color:'rgba(245,240,232,0.35)', fontWeight:400, letterSpacing:1 }}>{e.years}</span></p>
                  <p style={{ fontSize:'.9rem', lineHeight:1.7, color:'rgba(245,240,232,0.7)', marginTop:'.25rem' }}>{e.note}</p>
                </div>
              </div>
            ))}
          </div>
          <div style={{ ...sb, margin:'2.5rem auto 0', maxWidth:650 }}>
            <p style={sbText}>"The wicked shall be turned into hell, and all the nations that forget God."</p>
            <p style={sbRef}>Psalm 9:17</p>
          </div>
        </div>
      </section>

      <div className="divider" />

      {/* THE REAL ISSUE */}
      <section style={{ background:'linear-gradient(180deg,var(--navy),var(--deep-blue))' }}>
        <div className="inner" style={{ maxWidth:750 }}>
          <h2 className="section-title" style={{ fontSize:'clamp(1.4rem,3vw,2rem)' }}>God Does Not See<br />Americans and Foreigners</h2>
          <div className="about-content">
            <p>We love America. This entire website is dedicated to calling America back to God. We believe God has blessed this nation in extraordinary ways.</p>
            <p>None of that means being born in America gives you a special standing before God. The farmer in Kenya who trusts in Jesus Christ is closer to God than the American who sits in church every Sunday yet has never been born again.</p>
            <p>God does not have an American section in heaven. He does not give preferential treatment based on geography. The ground at the foot of the cross is level. Every soul, from every nation, in every generation, faces the same question: what will you do with Jesus Christ?</p>
          </div>
          <div style={{ ...sb, margin:'2rem auto', maxWidth:650 }}>
            <p style={sbText}>"For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."</p>
            <p style={sbRef}>John 3:16</p>
          </div>
          <div className="about-content">
            <p>"Whosoever" is the most democratic word in the Bible. It does not say "For God so loved America." It says "For God so loved the world." Salvation is offered to every human being on equal terms: believe on the Lord Jesus Christ, and thou shalt be saved.</p>
          </div>
        </div>
      </section>

      <div className="divider divider-gold" />

      {/* WHAT DOES MAKE YOU RIGHT */}
      <section style={{ background:'var(--deep-blue)' }}>
        <div className="inner">
          <h2 className="section-title" style={{ fontSize:'clamp(1.4rem,3vw,2rem)' }}>What Actually Makes You<br />Right with God</h2>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(300px,1fr))', gap:'1.5rem', marginTop:'.5rem' }}>
            <div style={{ padding:'2.5rem 2rem', background:'rgba(178,34,52,0.06)', border:'1px solid rgba(178,34,52,0.12)', textAlign:'center' }}>
              <div style={{ fontFamily:"'Playfair Display',serif", fontSize:'3rem', color:'var(--crimson)', opacity:.5, marginBottom:'.5rem' }}>I</div>
              <h3 style={{ fontFamily:"'Playfair Display',serif", fontSize:'1.2rem', color:'var(--white)', marginBottom:'.75rem' }}>Acknowledge Your Sin</h3>
              <p style={{ fontSize:'.9rem', lineHeight:1.8, color:'rgba(245,240,232,0.75)', marginBottom:'1rem' }}>Every person, in every nation, has sinned against God. No amount of national pride, cultural heritage, or civic virtue changes that reality.</p>
              <div style={{ borderLeft:'3px solid var(--gold)', padding:'.5rem 1rem', background:'rgba(197,165,90,0.04)', textAlign:'left' }}>
                <p style={{ fontFamily:"'Playfair Display',serif", fontStyle:'italic', fontSize:'.85rem', lineHeight:1.7, color:'rgba(245,240,232,0.85)' }}>"For all have sinned, and come short of the glory of God."</p>
                <p style={{ fontFamily:"'Oswald',sans-serif", fontSize:'.7rem', letterSpacing:2, color:'var(--gold)' }}>Romans 3:23</p>
              </div>
            </div>
            <div style={{ padding:'2.5rem 2rem', background:'rgba(178,34,52,0.06)', border:'1px solid rgba(178,34,52,0.12)', textAlign:'center' }}>
              <div style={{ fontFamily:"'Playfair Display',serif", fontSize:'3rem', color:'var(--crimson)', opacity:.5, marginBottom:'.5rem' }}>II</div>
              <h3 style={{ fontFamily:"'Playfair Display',serif", fontSize:'1.2rem', color:'var(--white)', marginBottom:'.75rem' }}>Believe on Jesus Christ</h3>
              <p style={{ fontSize:'.9rem', lineHeight:1.8, color:'rgba(245,240,232,0.75)', marginBottom:'1rem' }}>Salvation is not found in a nation, a culture, a church, or a political party. It is found in a Person: the Lord Jesus Christ, who died for your sins and rose again.</p>
              <div style={{ borderLeft:'3px solid var(--gold)', padding:'.5rem 1rem', background:'rgba(197,165,90,0.04)', textAlign:'left' }}>
                <p style={{ fontFamily:"'Playfair Display',serif", fontStyle:'italic', fontSize:'.85rem', lineHeight:1.7, color:'rgba(245,240,232,0.85)' }}>"Believe on the Lord Jesus Christ, and thou shalt be saved."</p>
                <p style={{ fontFamily:"'Oswald',sans-serif", fontSize:'.7rem', letterSpacing:2, color:'var(--gold)' }}>Acts 16:31</p>
              </div>
            </div>
            <div style={{ padding:'2.5rem 2rem', background:'rgba(178,34,52,0.06)', border:'1px solid rgba(178,34,52,0.12)', textAlign:'center' }}>
              <div style={{ fontFamily:"'Playfair Display',serif", fontSize:'3rem', color:'var(--crimson)', opacity:.5, marginBottom:'.5rem' }}>III</div>
              <h3 style={{ fontFamily:"'Playfair Display',serif", fontSize:'1.2rem', color:'var(--white)', marginBottom:'.75rem' }}>Receive Eternal Life</h3>
              <p style={{ fontSize:'.9rem', lineHeight:1.8, color:'rgba(245,240,232,0.75)', marginBottom:'1rem' }}>The moment you trust in Christ, you are saved. Not because of where you live, what language you speak, or what flag you salute. Because of what Jesus did for you on the cross.</p>
              <div style={{ borderLeft:'3px solid var(--gold)', padding:'.5rem 1rem', background:'rgba(197,165,90,0.04)', textAlign:'left' }}>
                <p style={{ fontFamily:"'Playfair Display',serif", fontStyle:'italic', fontSize:'.85rem', lineHeight:1.7, color:'rgba(245,240,232,0.85)' }}>"For by grace are ye saved through faith; and that not of yourselves: it is the gift of God."</p>
                <p style={{ fontFamily:"'Oswald',sans-serif", fontSize:'.7rem', letterSpacing:2, color:'var(--gold)' }}>Ephesians 2:8</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="divider" />

      {/* CTA */}
      <section style={{ background:'linear-gradient(165deg,#1B3A6B 0%,var(--deep-blue) 50%,var(--navy) 100%)', textAlign:'center', padding:'5rem 2rem' }}>
        <div className="inner" style={{ maxWidth:700 }}>
          <div style={{ fontSize:'3rem', marginBottom:'1rem', color:'var(--gold)', textShadow:'0 0 40px rgba(197,165,90,0.2)' }}>✝</div>
          <h2 className="section-title" style={{ fontSize:'clamp(1.5rem,3.5vw,2.2rem)', marginBottom:'1.5rem' }}>
            Heaven Is Not Reserved<br />for Any One Nation
          </h2>
          <p style={{ fontSize:'1.05rem', lineHeight:1.9, color:'rgba(245,240,232,0.8)', maxWidth:550, margin:'0 auto 1.5rem' }}>
            "For whosoever shall call upon the name of the Lord shall be saved." (Romans 10:13). That "whosoever" includes you, regardless of where you were born.
          </p>
          <div style={{ display:'flex', gap:'1.5rem', justifyContent:'center', flexWrap:'wrap' }}>
            <Link to="/salvation" className="btn-p">How to Be Saved</Link>
            <Link to="/bible/43/3" className="btn-s">Read the Gospel of John</Link>
          </div>
        </div>
      </section>
    </>
  );
}
